export default {
    TITLE : "DELICATE_1",
    NORMAL : "Cormorant"
}